import classNames from 'classnames';
import { useRef } from 'react';
import Icon from '../Icon';
import ContentBlock from '../ContentBlock';
import FlexContainer from '../FlexContainer';
import Txt from '../Txt';
import View from '../View';
import styles from './Modal.module.scss';

/**
 * Modal
 *
 * @return {JSX.Element}
 */
const Modal = ({
  className,
  absolute,
  onClose,
  children,
  scrollContainer,
  top,
  title,
  showCloseButton,
  overflowHidden,
  noPadding,
  fullHeight,
  transparent,
  ...rest
}) => {
  const ref = useRef();

  const handleClose = (e) => {
    onClose?.(e);
  };

  const handleClickClose = (e) => {
    if (e.button === 0) {
      const { target, currentTarget } = e;
      if (target === currentTarget) {
        handleClose(e);
      }
    }
  };

  // useEffect(() => {
  //   const parent = ref.current.parentNode;
  //   const isInGlobalCtx = parent.classList.contains('__ModalGlobal__');
  //   const scrollEl =
  //     parent.closest(`.${styles.Modal}`) || document.documentElement;
  //   const isParentHTML = scrollEl === document.documentElement;
  //   // const isAlreadyApplied =
  //   //   isParentHTML && scrollEl.style.overflow === 'hidden';
  //
  //   const effect = () => {
  //     // scrollEl.scrollTo(0, 0);
  //     scrollEl.style.overflow = 'hidden';
  //
  //     return () => {
  //       scrollEl.style.overflow = '';
  //     };
  //   };
  //   // If the Modal is rendered inside ModalGlobal, skip all this
  //   if (
  //     // if parent is HTMLDoc and overlow isn't set
  //     (isParentHTML && scrollEl.style.overflow !== 'hidden') ||
  //     // If parent is another modal and not in global context
  //     (!isParentHTML && !isInGlobalCtx)
  //   ) {
  //     return effect();
  //   }
  // }, []);

  return (
    <View
      ref={ref}
      className={classNames(
        styles.Modal,
        className,
        `${Modal.displayName}`,
        absolute && styles.Modal__absolute,
        top && styles.Modal__top,
        fullHeight && styles.Modal__fullHeight,
        scrollContainer && styles.Modal__scrollContainer
      )}
      onMouseDown={handleClickClose}
    >
      <ContentBlock
        className={classNames(styles.Content, className)}
        column
        transparent={transparent}
        overflowHidden={overflowHidden}
        noPadding
      >
        {title ? (
          <FlexContainer className={styles.Header} alignCenter spaceBetween gap>
            <Txt bold xxx>
              {title}
            </Txt>
            {showCloseButton ? (
              <Icon name="close" onClick={handleClose} />
            ) : null}
          </FlexContainer>
        ) : null}
        <FlexContainer
          className={classNames(
            styles.Body,
            noPadding && styles.Body__noPadding
          )}
          {...rest}
        >
          {children}
        </FlexContainer>
      </ContentBlock>
    </View>
  );
};

Modal.displayName = 'Modal';

export default Modal;
